module.exports = __webpack_public_path__ + "static/img/chuzhongyuwen2.dac3e123.jpg";